import api from './api'
import { Product, ProductCategory } from '@/types'

export interface ProductFilters {
  product_type?: string
  network_type?: string
  sim_type?: string
  broadband_category?: string
  multisim_category?: string
  is_contract?: boolean
  is_pay_and_go?: boolean
  is_public?: boolean
  show_in_shop?: boolean
  category_id?: number
  min_price?: number
  max_price?: number
  skip?: number
  limit?: number
}

export const productService = {
  async getProducts(filters?: ProductFilters): Promise<Product[]> {
    const response = await api.get<{ count: number; products: Product[] }>('/products', { params: filters })
    return response.data.products || []
  },

  async getProduct(idOrSlug: number | string): Promise<Product> {
    const response = await api.get<Product>(`/products/${idOrSlug}`)
    return response.data
  },

  async getCategories(): Promise<ProductCategory[]> {
    const response = await api.get<ProductCategory[]>('/products/categories')
    return response.data
  },

  async validateDiscountCode(
    code: string,
    product_ids: number[]
  ): Promise<{ valid: boolean; discount_type: string; discount_value: number }> {
    const response = await api.post('/products/validate-discount', {
      code,
      product_ids,
    })
    return response.data
  },

  // Admin functions
  async createProduct(data: Partial<Product>): Promise<Product> {
    const response = await api.post<Product>('/products', data)
    return response.data
  },

  async updateProduct(id: number, data: Partial<Product>): Promise<Product> {
    const response = await api.put<Product>(`/products/${id}`, data)
    return response.data
  },

  async deleteProduct(id: number): Promise<void> {
    await api.delete(`/products/${id}`)
  },

  async createCategory(data: Partial<ProductCategory>): Promise<ProductCategory> {
    const response = await api.post<ProductCategory>('/products/categories', data)
    return response.data
  },
}
